import React, { Component } from 'react';
import BuscarYCrearPersona from '../../procesos/BuscarYCrearPersona';
import { Layout, notification, Form, Input, Radio, Button, Select, Modal } from 'antd/lib';
import { useQuery } from '@apollo/react-hooks';
import { graphql, compose, withApollo } from 'react-apollo';

import * as actionsPersonas from '../../../actions/personas';
import * as actionsMain from '../../../actions/main';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';
import getCiudades from '../../../graphql/querys/organismos/getCiudades.graphql';
import getEmpleadorPorCUIT from '../../../graphql/querys/empleador/getEmpleadorPorCUIT.graphql';

const FormItem = Form.Item;
const { Option } = Select;

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

// Functional component for Ciudad selector with GraphQL
const CiudadSelector = (props) => {
  const { data, loading, error } = useQuery(getCiudades, {
    fetchPolicy: 'network-only',
  });

  if (loading) return <Select loading placeholder="Cargando ciudades..." {...props} />;
  if (error) return <Select placeholder="Error al cargar ciudades" {...props} />;

  const ciudades = data.getCiudades || [];

  return (
    <Select
      showSearch
      placeholder="Seleccione una ciudad"
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      {...props}
    >
      {ciudades.map(ciudad => (
        <Option key={ciudad._id} value={ciudad._id}>
          {ciudad.nombre}
        </Option>
      ))}
    </Select>
  );
};

class CrearEmpleador extends Component {
  formRef = React.createRef();
  
  state = {
    empleador: {
      tipoPersona: 'HUMANA',
      nombre: '',
      cuit: '',
      domicilio: '',
      actividad: '',
      ciudad: '',
    },
    tipoPersona: 'HUMANA', // 'HUMANA' or 'juridica'
  };

  componentDidMount() {
    // If there's saved data in props, restore it
    if (this.props.empleadorData) {
      this.setState({
        empleador: this.props.empleadorData,
        tipoPersona: this.props.empleadorData.tipoPersona || 'HUMANA',
      });
      // Set form values
      if (this.formRef.current) {
        this.formRef.current.setFieldsValue(this.props.empleadorData);
      }
    }
  }

  handleTipoPersonaChange = (e) => {
    this.setState({ tipoPersona: e.target.value });
  };

  handleNombreChange = (e) => {
    const upperValue = e.target.value.toUpperCase();
    if (this.formRef.current) {
      this.formRef.current.setFieldsValue({ nombre: upperValue });
    }
  };

  handleSubmit = async (values) => {
    // Convert nombre to uppercase
    const empleadorData = {
      ...values,
      nombre: values.nombre ? values.nombre.toUpperCase() : '',
    };
    
    // Save to state
    this.setState({ empleador: empleadorData });
    
    console.log('Form values:', empleadorData);

    this.props.onSubmit(empleadorData);
  };

  handleCancel = () => {
    this.props.actionsMain.setCargaPersonas(
      !this.props.main.cargaPersonasToggle
    );

    this.props.onCancel();
  };

  guardarPersona = persona => {
    let per = false;  //Para la autorizacion de viaje de menores, se permite cargar una misma persona como padre y autorizante

    if (per) {
      //Esto significa que ya existia la persona y no debo volver a cargarla.
      notification.error({
        message: 'Persona Existente',
        description:
          'La persona que intento ingresar, ya existia en la autorizacion',
      });
      this.props.actionsMain.setCargaPersonas(
        !this.props.main.cargaPersonasToggle
      );
    } else {
      this.setState(
        {
          ...this.state,
          persona: {
            ...this.state.persona,
            ...persona,
          },
        },
        () => {
          // this.props.history.push('agregarPersona/')

          //Actualizar REDUX
          this.props.actionsPersonas.agregarPersona(persona);
          this.props.actionsMain.setCargaPersonas(
            !this.props.main.cargaPersonasToggle
          );

          // //REDIRIGIR
          // this.props.history.goBack();
        }
      );
    }
  };

  onCancel = () => {
    this.props.onCancel();
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <div style={estiloContent}>
            <h2 style={{ textAlign: 'center', marginBottom: 24 }}>
              Crear Empleador
            </h2>
            
            <Form
              ref={this.formRef}
              onFinish={this.handleSubmit}
              onValuesChange={(changedValues, allValues) => {
              }}
              initialValues={this.state.empleador}
            >
              <FormItem
                {...formItemLayout}
                name="tipoPersona"
                label="Tipo de Persona"
                rules={[{ required: true, message: 'Por favor seleccione el tipo de persona' }]}
              >
                <Radio.Group onChange={this.handleTipoPersonaChange}>
                  <Radio value="HUMANA">Persona Humana</Radio>
                  <Radio value="JURIDICA">Persona Jurídica</Radio>
                </Radio.Group>
              </FormItem>

              {this.state.tipoPersona === 'HUMANA' ? (
                <FormItem
                  {...formItemLayout}
                  name="nombre"
                  label="Nombre y Apellido"
                  rules={[
                    { required: true, message: 'Por favor ingrese el nombre y apellido' },
                    { whitespace: true, message: 'El campo no puede estar vacío' }
                  ]}
                >
                  <Input 
                    placeholder="Ej: JUAN PÉREZ" 
                    style={{ width: 500 }} 
                    onChange={this.handleNombreChange}
                  />
                </FormItem>
              ) : (
                <FormItem
                  {...formItemLayout}
                  name="nombre"
                  label="Nombre de la Empresa"
                  rules={[
                    { required: true, message: 'Por favor ingrese el nombre de la empresa' },
                    { whitespace: true, message: 'El campo no puede estar vacío' }
                  ]}
                >
                  <Input 
                    placeholder="Ej: EMPRESA SA" 
                    style={{ width: 500 }} 
                    onChange={this.handleNombreChange}
                  />
                </FormItem>
              )}

              <FormItem
                {...formItemLayout}
                name="cuit"
                label="CUIT/CUIL"
                rules={[
                  { required: true, message: 'Por favor ingrese el CUIT' },
                  { pattern: /^\d{11}$/, message: 'El CUIT debe tener 11 dígitos sin guiones' }
                ]}
              >
                <Input placeholder="Ej: 20123456789" style={{ width: 500 }} maxLength={11} />
              </FormItem>

              <FormItem
                {...formItemLayout}
                name="domicilio"
                label="Domicilio"
                rules={[
                  { required: true, message: 'Por favor ingrese el domicilio' },
                  { whitespace: true, message: 'El campo no puede estar vacío' }
                ]}
              >
                <Input placeholder="Ej: Calle 123" style={{ width: 500 }} />
              </FormItem>

              <FormItem
                {...formItemLayout}
                name="actividad"
                label="Actividad"
                rules={[
                  { required: true, message: 'Por favor ingrese la actividad' },
                  { whitespace: true, message: 'El campo no puede estar vacío' }
                ]}
              >
                <Input placeholder="Ej: Comercio" style={{ width: 500 }} />
              </FormItem>

              <FormItem
                {...formItemLayout}
                name="ciudad"
                label="Ciudad"
                rules={[{ required: true, message: 'Por favor seleccione la ciudad' }]}
              >
                <CiudadSelector style={{ width: 500 }} />
              </FormItem>

              <FormItem {...tailFormItemLayout}>
                <Button type="primary" htmlType="submit" style={{ marginRight: 8 }}>
                  Confirmar
                </Button>
                <Button type="danger" onClick={this.handleCancel}>
                  Cancelar
                </Button>
              </FormItem>
            </Form>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsPersonas: bindActionCreators(actionsPersonas, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(CrearEmpleador));
